import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdEdit, MdMessage, MdRemoveRedEye } from 'react-icons/lib/md';

import { mediumModalStyle, mediumModalStyleMedia } from '../../constants';
import { withAuth } from '../../actions/';
import { fetchStatusComments } from '../../actions/project_actions';
import { getDateValue } from '../../utils/date';
import CommentsForm from './CommentsForm';
import AddCommentForm from './AddCommentForm';
import CommentsViewForm from './CommentsViewForm';

class Comments extends Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   permissions: PropTypes.object.isRequired,
  //   statusComments: PropTypes.array.isRequired,
  //   fetchStatusComments: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);
    this.state = {
      toEdit: null,
    }
    this.startEdit = this.startEdit.bind(this);
    this.onDone = this.onDone.bind(this);
    this.putOrPost = this.putOrPost.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.loadInitial();
  }

  loadInitial () {
   this.props.fetchStatusComments(this.props.projectId);
  }

  startEdit (toEdit) {
    this.setState({ toEdit })
  }

  startDelete (toDelete) {
    this.setState({ toDelete })
  }

  onDone (shouldFetch) {
    if (shouldFetch) this.loadInitial();
    this.setState({ toEdit: null, toDelete: null});
  }

  putOrPost (comment) { 
    let url, method;
    const { projectId } = this.props;
    comment.projectId = projectId; 
    const statusComment = {
      Comment: comment.comment,
      StatusComment: {
        StatusForProject: comment.statusForProject,
        Id: comment.id,
        ActivityIssueId: comment.activityIssueId,
        Comment: comment.comment,
        ProjectId: comment.projectId,
        TypeId: comment.typeId,
      } 
    };

    if (comment.id) {
      method = 'put';
      url = `/projects/${projectId}/statusComments`;  
    } else {
      method = 'post';
      url = `/projects/${projectId}/statusComments/`; 
    }

    withAuth(
      {method, url, data: statusComment},
      () => this.onDone(true)
    );
  }

  renderEditForm (toEdit) {
    const { roleModules } = this.props.permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('Status comments') 
    ? true : false;

    let heading = 'View Status / Activity';
    
    if (canEdit) {
      heading = 'Edit status / Activity';
    }

    if (toEdit.id) {
      return (
        <div>
          <h1>{heading}</h1>
          {canEdit
            ? <CommentsForm
              comment={toEdit}
              onSubmit={this.putOrPost}
            />
            : <CommentsViewForm
              comment={toEdit}
              onSubmit={this.putOrPost}
            />
          }
          <div className="modal-close" onClick={this.onDone}>
            <span className="close"></span>
          </div>
        </div>
      );
    }

    else {
        return (
          <div>
          <h1>Add Status / Activity</h1>
          <AddCommentForm
          comment={toEdit}
            onSubmit={this.putOrPost}
          />         
          <div className="modal-close" onClick={this.onDone}>
            <span className="close"></span>
          </div>
        </div>
        );      
      }
  }

  renderModal () {
    const { toEdit } = this.state;
    const isOpen = !(toEdit === null);
   
    if (window.innerWidth < 768) {
    return (
      <Modal
        isOpen={isOpen}
        style={mediumModalStyleMedia}
        contentLabel="Comment form"
      >
        {toEdit && this.renderEditForm(toEdit)}
      </Modal>
    );
  }
  else {
    return (
      <Modal
        isOpen={isOpen}
        style={mediumModalStyle}
        contentLabel="Comment form"
      >
        {toEdit && this.renderEditForm(toEdit)}
      </Modal>
    );
  }
  }

  renderRowButtons(comment) {
    const { roleModules } = this.props.permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('Status comments') 
    ? true : false;

    return (
      <td>
        {canEdit
          ? <button onClick={() => this.startEdit(comment)}>
            <span><MdEdit size={20} color='#8492a6' /></span>
          </button>
          : <button onClick={() => this.startEdit(comment)}>
            <span><MdRemoveRedEye size={20} color='#8492a6' /></span>
          </button>
        }
      </td>
    )
  }

  renderTable (statusComments) {

    return (
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Status / Activity</th>
              <th>Created By</th>
              <th>Created Date</th>
              <th>Last Updated By</th>
              <th>Updated Date</th>
              <th>Actions</th> 
            </tr>
          </thead>
           <tbody>
          { statusComments.map(comment =>
            <tr key={comment.id}>
              {comment.typeId === 1
              ? <td>Current Status</td>
              : <td>Activities and Issues</td>
              }
              {comment.statusForProject
              ? <td>{comment.statusForProject}</td>
              :  <td>{comment.lkp_ActivitiesIssues.description}</td>           
              }           
              <td>{comment.createdUserUniqueName}</td>
              <td>{getDateValue(comment.createdDate)}</td>
              <td>{comment.modifiedUserUniqueName}</td>
              <td>{getDateValue(comment.modifiedDate)}</td>
              {  this.renderRowButtons(comment) }
            </tr>
          )}
          </tbody> 
        </table>
      </div>
    );
  }

  render () {
    const { statusComments } = this.props;
    const { roleModules } = this.props.permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('Status comments') 
    ? true : false;

    return (
      <div id="comments" className="row-wide project-logs">
        <div className="col s12">
          <h4 className="bar-bottom">
            <span><MdMessage size={20} /></span> Status
          </h4>
        </div>
         {this.renderModal()} 
        <div className="col s12">
          { statusComments.length
            ? this.renderTable(statusComments)
            : <div>This project has no comments yet.</div> }
        </div>
        { canEdit
          ? <div className="section-buttons">
              <button className="btn-save" onClick={() => this.startEdit({})}>
                Add
              </button>
            </div>
          : null }
      </div>
    );
  }
}

Comments.propTypes = {
  projectId: PropTypes.string.isRequired,
  permissions: PropTypes.object.isRequired,
  statusComments: PropTypes.array.isRequired,
  fetchStatusComments: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
  return {
    projectId: ownProps.projectId,
    statusComments: state.projectsStore.statusComments,
  };
}

export default connect(mapStateToProps, {fetchStatusComments})(Comments);